import router from './router/index';
import { getAccount } from '@/utils/user';

let accountInfo = getAccount();
// 没token也可以访问的路径白名单
const whiteList = ['/login'];
router.beforeEach((to, from, next) => {
  if (from.name === 'Login') {
    accountInfo = getAccount();
  }
  if (accountInfo && accountInfo.token) {
    if (to.name === 'Login') {
      from.name ? next(false) : next('/');
      return;
    }
    // if (to.name === null && to.path !== '/') {
    //   next(new Error('链接错误,无法访问'));
    //   return;
    // }
    next();
  } else {
    if (whiteList.indexOf(to.path) === -1) {
      next({name: 'Login', query: {redirect: to.fullPath}});
    } else {
      next();
    }
  }
});
